import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { FaArrowUp } from 'react-icons/fa6';
import {
  displayValue,
  displayValueWithUnit,
  hasValue,
} from '../../../../../utils/valueFormatting/display.utils';

export const weatherDetails = [
  {
    id: 'temperature',
    label: 'Temperature',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TEMPERATURE,
    getValue: (data) => displayValueWithUnit(data?.temperature, '°F'),
  },
  {
    id: 'humidity',
    label: 'Humidity',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HUMIDITY,
    getValue: (data) => displayValueWithUnit(data?.humidity, '%'),
  },
  {
    id: 'comfort',
    label: 'Feels Like',
    iconKey: WEATHER_DETAIL_ICON_KEYS.COMFORT,
    getValue: (data) => displayValueWithUnit(data?.comfort, '°F'),
  },
  {
    id: 'visibility',
    label: 'Visibility',
    iconKey: WEATHER_DETAIL_ICON_KEYS.VISIBILITY,
    getValue: (data) => displayValueWithUnit(data?.visibility, ' mi'),
  },
  {
    id: 'windSpeed',
    label: 'Wind',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (data) => displayValueWithUnit(data?.wind_speed, ' MPH'),
  },
  {
    id: 'windDirection',
    label: 'Wind Direction',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION,
    getValue: (data) => (
      <div className="d-flex align-items-center gap-1">
        <span>{`${displayValue(data?.wind_short)} (${displayValue(data?.wind_dir)}°)`}</span>
        {hasValue(data?.wind_dir) && (
          <FaArrowUp
            aria-hidden="true"
            focusable="false"
            size={16}
            style={{ transform: `rotate(${data.wind_dir}deg)` }}
          />
        )}
      </div>
    ),
  },
  {
    id: 'dewPoint',
    label: 'Dew Point',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DEW_POINT,
    getValue: (data) => displayValueWithUnit(data?.dew_point, '°F'),
  },
  {
    id: 'precipitationProbability',
    label: 'Precipitation',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRECIPITATION_PROBABILITY,
    getValue: (data) => displayValueWithUnit(data?.precip_prob, '%'),
  },
];
